import DashboardRoutes from "./DashboardRoutes";

export {DashboardRoutes};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/areas/dashboard/DashboardRoutes/index.tsx